exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query-template[data-v-0b7c29f8]{display:inline-block}.module-template[data-v-0b7c29f8]{display:inline-block}\n", ""]);

// exports
